<div *ngIf="statusInfo$ | async as statusInfo" class="cfs-status {{ statusInfo.type }}">
  <span class="cfs-status__text">{{ statusInfo.label | transloco }}</span>
</div>
